export const getTime_api = {
	url: 'maijiaDownloadtime',
	method: 'get'
}

export const getpf_api = {
	url: 'getmaijiaprofession',
	method: 'get'
}



// WEBPACK FOOTER //
// ./src/views/maijia/maijia-profession/desc.js